import InboxManager from '@/components/admin/InboxManager';
import { Badge } from '@/components/ui/badge';

const columns = [
    { key: 'name', label: 'Name', primary: true },
    { key: 'email', label: 'Email' },
    { key: 'phone', label: 'Phone' },
    { key: 'city', label: 'City' },
    {
        key: 'availability',
        label: 'Availability',
        render: (r) => (r.availability ? <Badge variant="outline">{r.availability}</Badge> : '—'),
    },
    {
        key: 'created_at',
        label: 'Date',
        render: (r) => <span className="text-xs">{r.created_at?.slice(0, 10)}</span>,
    },
];

const renderDetail = (v) => (
    <div className="space-y-3 text-sm">
        <Row label="Name">{v.name}</Row>
        <Row label="Email">
            <a href={`mailto:${v.email}`} className="text-[hsl(var(--primary))] hover:underline">
                {v.email}
            </a>
        </Row>
        <Row label="Phone">
            <a href={`tel:${v.phone}`} className="text-[hsl(var(--primary))] hover:underline">
                {v.phone}
            </a>
        </Row>
        <Row label="City / District">{v.city || v.district || '—'}</Row>
        <Row label="Availability">{v.availability || '—'}</Row>
        <Row label="Interests">
            {(v.interests || []).length ? (
                <div className="flex flex-wrap gap-1.5">
                    {v.interests.map((i) => (
                        <Badge key={i} variant="secondary">
                            {i}
                        </Badge>
                    ))}
                </div>
            ) : (
                '—'
            )}
        </Row>
        <Row label="Skills">{v.skills || '—'}</Row>
        <Row label="Motivation">
            <div className="text-foreground/85 whitespace-pre-line">{v.motivation || '—'}</div>
        </Row>
        <Row label="Submitted">
            <span className="text-xs text-muted-foreground">{v.created_at}</span>
        </Row>
    </div>
);

const Row = ({ label, children }) => (
    <div className="grid grid-cols-3 gap-4">
        <div className="text-muted-foreground text-xs uppercase tracking-widest font-medium">
            {label}
        </div>
        <div className="col-span-2">{children}</div>
    </div>
);

export default function AdminVolunteersPage() {
    return (
        <InboxManager
            kind="volunteers"
            title="Volunteer registrations"
            description="All volunteer sign-ups submitted from the public site."
            columns={columns}
            renderDetail={renderDetail}
        />
    );
}
